import {
  CalculusEnum,
  EnamelEnum,
  FractureEnum,
  FurcationEnum,
  GingivitisEnum,
  MobilityEnum,
  OtherEnum,
  PeriodontalEnum,
  ResorptionEnum,
  ToothStateEnum
} from "requests";

export const MEASUREMENT_KEYS = [
  "periodontalPocketMBuc",
  "periodontalPocketBuccal",
  "periodontalPocketDBuc",
  "periodontalPocketMLingPal",
  "periodontalPocketLingPal",
  "periodontalPocketDLingPal",
  "gingivalRecessionMBuc",
  "gingivalRecessionBuccal",
  "gingivalRecessionDBuc",
  "gingivalRecessionMLingPal",
  "gingivalRecessionLingPal",
  "gingivalRecessionDLingPal"
] as const;

export const DIAGNOSIS_KEYS = [
  "periodontal",
  "furcation",
  "mobility",
  "gingivitis",
  "calculus",
  "enamel",
  "fracture",
  "resorption"
] as const;

export const TOOTH_DIAGNOSIS_LABELS = {
  [ToothStateEnum.Extracted]: "Extracted",
  [ToothStateEnum.Missing]: "Missing",
  [ToothStateEnum.Abnormal]: "Abnormal",
  [ToothStateEnum.Untreated]: "Untreated",
  [ToothStateEnum.Treated]: "Treated",
  [PeriodontalEnum.Pd1]: "PD1",
  [PeriodontalEnum.Pd2]: "PD2",
  [PeriodontalEnum.Pd3]: "PD3",
  [PeriodontalEnum.Pd4]: "PD4",
  [FurcationEnum.F1]: "F1",
  [FurcationEnum.F2]: "F2",
  [FurcationEnum.F3]: "F3",
  [MobilityEnum.M1]: "M1",
  [MobilityEnum.M2]: "M2",
  [MobilityEnum.M3]: "M3",
  [GingivitisEnum.Gi1]: "GI1",
  [GingivitisEnum.Gi2]: "GI2",
  [GingivitisEnum.Gi3]: "GI3",
  [CalculusEnum.C1]: "C1",
  [CalculusEnum.C2]: "C2",
  [CalculusEnum.C3]: "C3",
  [EnamelEnum.Ab]: "AB",
  [EnamelEnum.At]: "AT",
  [EnamelEnum.Ca]: "CA",
  [EnamelEnum.ED]: "E/D",
  [EnamelEnum.EH]: "E/H",
  [EnamelEnum.EHm]: "E/HM",
  [FractureEnum.TFxEi]: "T/FX/EI",
  [FractureEnum.TFxEf]: "T/FX/EF",
  [FractureEnum.TFxUcf]: "T/FX/UCF",
  [FractureEnum.TFxCcf]: "T/FX/CCF",
  [FractureEnum.TFxUcrf]: "T/FX/UCRF",
  [FractureEnum.TFxCcrf]: "T/FX/CCRF",
  [FractureEnum.TFxRf]: "T/FX/RF",
  [ResorptionEnum.Tr1]: "TR1",
  [ResorptionEnum.Tr2]: "TR2",
  [ResorptionEnum.Tr3]: "TR3",
  [ResorptionEnum.Tr4]: "TR4",
  [ResorptionEnum.Tr5]: "TR5",
  [OtherEnum.Dt]: "DT",
  [OtherEnum.Dtc]: "DTC",
  [OtherEnum.Cwd]: "CWD",
  [OtherEnum.Ge]: "GE",
  [OtherEnum.Gh]: "GH",
  [OtherEnum.Gm]: "GM",
  [OtherEnum.MnFx]: "MN/FX",
  [OtherEnum.MxFx]: "MX/FX",
  [OtherEnum.Oaf]: "OAF",
  [OtherEnum.Onf]: "ONF",
  [OtherEnum.Om]: "OM",
  [OtherEnum.Rot]: "ROT",
  [OtherEnum.Rr]: "RR",
  [OtherEnum.Rrt]: "RRT",
  [OtherEnum.Si]: "SI",
  [OtherEnum.TNv]: "T/NV",
  [OtherEnum.TPe]: "T/PE",
  [OtherEnum.TSn]: "T/SN"
};
